import { useState, useRef, ChangeEvent } from 'react';
import ArrowDownIcon from '../../assets/icons/new_icon/vector-dropdown.svg';
import FieldLabel from '../FieldLabel';
import { DropdownOption } from './interfaces';
import './Dropdown.scss';

interface Props {
  label: string;
  options: DropdownOption[];
  selectedOption: any;
  onSelectOption: (value: any) => void;
}

export default function Dropdown({
  label,
  options,
  selectedOption,
  onSelectOption,
}: Props) {
  const inputRef = useRef(null);
  const [search, setSearch] = useState<string>('');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const filteredOptions = options.filter((option: DropdownOption) => {
    return option.label.toUpperCase().includes(search.toUpperCase());
  });

  const onBlurInput = () => {
    setSearch('');
    setIsOpen(false);
  };

  const onClickInput = () => {
    if (isOpen) {
      onBlurInput();
    }
    setIsOpen(!isOpen);
  };

  const onChangeSearch = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearch(value);
    if (!isOpen) {
      setIsOpen(true);
    }
  };

  const onClickOption = (option: DropdownOption) => {
    onSelectOption(option.value);
    onBlurInput();
  };

  return (
    <div className='Dropdown'>
      <FieldLabel text={label} />
      <div
        className='FieldContainer'
        onClick={onClickInput}
        onBlur={onBlurInput}
      >
        <div
          className='ValueContainer'
        >
          <div
            className={`DisplayValue ${search !== '' ? 'Hidden' : ''}`}
          >
            {options
              .find((option: DropdownOption) => option.value === selectedOption )
              ?.label
            }
          </div>
          <img
            className={`${isOpen ? 'Flipped' : ''} ArrowIcon`}
            alt=''
            src={ArrowDownIcon}
          />
        </div>
        <input
          className={`${search !== '' ? '' : 'Hidden' }`}
          onClick={onClickInput}
          ref={inputRef}
          placeholder='All'
          value={search}
          onChange={onChangeSearch}
          type='text'
        />
      </div>
      <div
        className='DropdownOptions'
        hidden={!isOpen}
      >
        {filteredOptions.length === 0
          ? (
            <div className='NoOptions'>
              No results found.
            </div>
          )
          : (
            filteredOptions.map((option: DropdownOption, i) => (
              <div
                key={i}
                className='Option'
                onMouseDown={() => {
                  onClickOption(option);
                }}
              >
                {option.label}
              </div>
            ))
          )
        }
      </div>
    </div>
  );
}
